var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F7",
    fillRule: "nonzero",
    d: "M15.7499791,26.499994 C14.3702827,26.499994 13.2511677,25.3808408 13.2511677,24 L18.2487906,24 C18.2487906,25.3808408 17.1296756,26.499994 15.7499791,26.499994 Z M24.1636172,20.6519626 C24.3979917,20.9035413 24.5019038,21.2050924 24.4999583,21.500006 C24.4960673,22.1406447 23.9929099,22.750003 23.2460703,22.750003 L8.253888,22.750003 C7.50704835,22.750003 7.0043106,22.1406447 7,21.500006 C6.99805451,21.2050924 7.10196661,20.9039228 7.33634106,20.6519626 C8.09100082,19.8410362 9.50312208,18.6210989 9.50312208,14.6250224 C9.50312208,11.5898657 11.6312222,9.16017637 14.5007451,8.5640932 L14.5007451,7.75003874 C14.5007451,7.05980907 15.0601309,6.50004172 15.7499791,6.50004172 C16.4398273,6.50004172 16.9992132,7.05980907 16.9992132,7.75003874 L16.9992132,8.5640932 C19.8687361,9.16017637 21.9968362,11.5898657 21.9968362,14.6250224 C21.9968362,18.6210989 23.4089575,19.8410362 24.1636172,20.6519626 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.0c3f44ab.svg";
export { ForwardRef as ReactComponent };